function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.2088 4.07595H11.7911V0H11.2088V4.07595ZM11.5 5.82278C8.53008 5.82278 6.11392 8.23895 6.11392 11.2089C6.11392 14.1788 8.53008 16.5949 11.5 16.5949C14.4699 16.5949 16.8861 14.1788 16.8861 11.2089C16.8861 8.23895 14.4699 5.82278 11.5 5.82278ZM11.5 17.1772C8.20896 17.1772 5.53164 14.4999 5.53164 11.2089C5.53164 7.91782 8.20896 5.24051 11.5 5.24051C14.791 5.24051 17.4684 7.91782 17.4684 11.2089C17.4684 14.4999 14.791 17.1772 11.5 17.1772ZM11.7911 23H11.2088V18.924H11.7911V23ZM0 11.7911H4.07595V11.2089H0V11.7911ZM23 11.7911H18.9241V11.2089H23V11.7911ZM6.3357 6.16511L3.45371 3.28312L3.86538 2.87145L6.74737 5.75344L6.3357 6.16511ZM16.835 16.6644L19.717 19.5464L20.1287 19.1348L17.2467 16.2528L16.835 16.6644ZM3.57412 19.5464L3.16245 19.1348L6.04444 16.2528L6.45611 16.6644L3.57412 19.5464ZM16.5438 5.75344L16.9555 6.16511L19.8374 3.28312L19.4258 2.87145L16.5438 5.75344Z",
  fill: "#6E6E6E"
});

var SvgHighSun = function SvgHighSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHighSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/high-sun.f4d5e603.svg";
export { ForwardRef as ReactComponent };